// extracted by mini-css-extract-plugin
var _1 = "PreferencesSettings_dropdown__6gEwV";
var _2 = "PreferencesSettings_dropdownCell__DeQ4e";
export { _1 as "dropdown", _2 as "dropdownCell" }
